module.exports = __webpack_public_path__ + "static/media/analytics.85291cce.svg";